/*
 * @Author: Han
 * @Date: 2021-12-08 10:22:43
 * @LastEditors: Han
 * @LastEditTime: 2021-12-20 13:33:18
 * @FilePath: \console\console\src\http\moudules\authorityManagement.js
 */
import axios from '../axios'

// 查看角色列表
export const getAutherList = (data) => {
  return axios({
    url: '/con/manage/role/list',
    method: 'GET',
    data
  })
}

// 查看用户列表
export const getUserList = (data) => {
  return axios({
    url: '/con/manage/user/list',
    method: 'GET',
    data
  })
}
// 获取角色列表
export const getUserAutherList = () => {
  return axios({
    url: '/con/manage/role/get_all_role',
    method: 'GET'
  })
}
// 用户名是否重复
export const checkAccountName = (data) => {
  return axios({
    url: '/con/user/checkAccountName',
    method: 'GET',
    data
  })
}
// 用户名是否重复
export const saveAcount = (data) => {
  return axios({
    url: '/con/manage/user/save',
    method: 'POST',
    data
  })
}
// 编辑帐号
export const updateAcount = (data) => {
  return axios({
    url: '/con/manage/user/edit',
    method: 'POST',
    data
  })
}
// 冻结解冻账户
export const xAcount = (data) => {
  return axios({
    url: '/con/manage/user/update_user_status',
    method: 'GET',
    data
  })
}
// 删除账户解冻账户
export const delCount = (data) => {
  return axios({
    url: '/con/manage/user/delete',
    method: 'GET',
    data
  })
}
// 重置密码
export const retCount = (data) => {
  return axios({
    url: '/con/manage/user/reset_passwd',
    method: 'GET',
    data
  })
}



// 角色

// 查询角色菜单
export const roleMenu = (data) => {
  return axios({
    url: '/con/manage/menu/get',
    method: 'GET',
    data
  })
}
// 添加角色
export const saveRole = (data) => {
  return axios({
    url: '/con/manage/role/save',
    method: 'POST',
    data
  })
}
// 角色查询对应菜单
export const idGetRoleMenu = (data) => {
  return axios({
    url: '/con/manage/role/get_role_menu',
    method: 'GET',
    data
  })
}
// 更新角色权限
export const updateRole = (data) => {
  return axios({
    url: '/con/manage/role/update',
    method: 'POST',
    data
  })
}
// 删除角色
export const delRole = (data) => {
  return axios({
    url: '/con/manage/role/delete',
    method: 'POST',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/authorityManagement.js